import React from 'react';
import { useParams } from 'react-router-dom';

import { AccessInformation } from '../components/AccessInformation/AccessInformation';
import { Permissions } from '../components/Permissions/Permissions';

export const PermissionsPage = () => {
    const { accesspointcode, permissionid } = useParams();

    return (
        <AccessInformation enabled={!!accesspointcode && !!permissionid}>
            {({ accessInformation, translations }) => {
                return (
                    <Permissions
                        accessInformation={accessInformation}
                        permissionId={permissionid}
                        translations={translations}
                    />
                );
            }}
        </AccessInformation>
    );
};
